<template>
  <Layout>
    <div class="bg-main flex h-screen overflow-hidden">
      <div class="flex-none transition-all duration-300">
        <SidebarManagement
          className="!bg-gray-700 !items-center !pb-6 !pt-10"
          :isShowLogo="false"
          :userImage="'/images/contents/avatar-default.png'"
          :userName="layoutData.userName"
          :heightItem="750"
          :menuList="layoutData.dataList"
          :onClickSubMenu="onClickMenu"
          :onClickLogo="
            () => {
              console.log('onClickLogo');
            }
          "
        />
      </div>
      <div class="flex-1 overflow-auto transition-all duration-300">
        <slot />
      </div>
    </div>

    <Notifications position="top center" :group="'tailwind'">
      <template #body="props">
        <Toast
          class="mt-2 mr-6"
          :isError="props.item.data.isError"
          :isWarning="props.item.data.isWarning"
          :isNotice="props.item.data.isNotice"
          :isDisabled="props.item.data.isDisabled"
          :label="props.item.text"
          :onClick="props.close"
        />
      </template>
    </Notifications>

    <!-- Loading Overlay -->
    <LoadingOverlay
      v-if="isShowLoading"
      :isFlow="true"
      :isPulse="false"
      :isCircleFade="false"
    />
  </Layout>
</template>

<script setup>
import 'prismjs/components/'; // Add other languages as needed
import 'prismjs/prism'; // Core
import 'prismjs/themes/prism.css'; // Use another theme if you prefer
const route = useRoute();
const { $router, $constants, $functions } = useNuxtApp();

const isShowLoading = useIsShowLoading();
const gUserAuthData = useUserAuthData();

const layoutData = reactive({
  userName: 'Admin',
  dataList: [
    {
      id: 0,
      icon: '/images/icons/ic-report-purple.svg',
      iconActive: '/images/icons/ic-report-white.svg',
      name: 'Dashboard',
      path: $constants.ROUTE.DASHBOARD.LINK,
      activeNameList: [$constants.ROUTE.DASHBOARD.NAME],
    },
    {
      id: 1,
      icon: '/images/icons/ic-chat-purple.svg',
      iconActive: '/images/icons/ic-chat-white.svg',
      name: 'Manage conversation',
      path: $constants.ROUTE.CONVERSATION.LINK,
      activeNameList: [
        $constants.ROUTE.CONVERSATION.NAME,
        $constants.ROUTE.CONVERSATION_MANAGE.NAME,
        $constants.ROUTE.CONVERSATION_MANAGE_DETAIL.NAME,
      ],
    },
    {
      id: 2,
      icon: '/images/icons/ic-bot.svg',
      iconActive: '/images/icons/ic-bot-fill.svg',
      name: 'Manage Room',
      path: $constants.ROUTE.PRESET.LINK,
      activeNameList: [
        $constants.ROUTE.PRESET.NAME,
        $constants.ROUTE.PRESET_MANAGE.NAME,
      ],
    },
    {
      id: 3,
      icon: '/images/icons/ic-bot.svg',
      iconActive: '/images/icons/ic-bot-fill.svg',
      name: 'Prompt Library',
      path: $constants.ROUTE.PROMPT.LINK,
      activeNameList: [$constants.ROUTE.PROMPT.NAME],
    },
    {
      id: 4,
      icon: '/images/icons/ic-clock.svg',
      iconActive: '/images/icons/ic-clock-fill.svg',
      name: 'Manage Quota',
      path: $constants.ROUTE.QUOTA.LINK,
      activeNameList: [
        $constants.ROUTE.QUOTA.NAME,
        $constants.ROUTE.QUOTA_MANAGE.NAME,
      ],
    },
    {
      id: 5,
      icon: '/images/icons/ic-lock-closed-area-outline.svg',
      iconActive: '/images/icons/ic-lock-closed-area-fill-white.svg',
      name: 'Access Management',
      path: $constants.ROUTE.USER.LINK,
      // isShowSubMenu: true,
      activeNameList: [
        $constants.ROUTE.APPLICATION.NAME,
        $constants.ROUTE.APPLICATION_MANAGE.NAME,
        $constants.ROUTE.SCOPE.NAME,
        $constants.ROUTE.SCOPE_MANAGE.NAME,
        $constants.ROUTE.USER.NAME,
        $constants.ROUTE.USER_MANAGE.NAME,
      ],
      // subMenu: [
      //   {
      //     name: 'Application',
      //     path: $constants.ROUTE.APPLICATION.LINK,
      //     activeNameList: [
      //       $constants.ROUTE.APPLICATION.NAME,
      //       $constants.ROUTE.APPLICATION_MANAGE.NAME,
      //     ],
      //   },
      //   {
      //     name: 'Scope',
      //     path: $constants.ROUTE.SCOPE.LINK,
      //     activeNameList: [
      //       $constants.ROUTE.SCOPE.NAME,
      //       $constants.ROUTE.SCOPE_MANAGE.NAME,
      //     ],
      //   },
      //   {
      //     name: 'User',
      //     path: $constants.ROUTE.USER.LINK,
      //     activeNameList: [
      //       $constants.ROUTE.USER.NAME,
      //       $constants.ROUTE.USER_MANAGE.NAME,
      //     ],
      //   },
      // ],
    },
  ],
});

onMounted(() => {
  getUserData();
});

const onClickMenu = (index) => {
  layoutData.dataList = layoutData.dataList.map((e, i) => {
    e.isActive = i === index;
    return e;
  });
};

const checkPath = () => {
  layoutData.dataList = layoutData.dataList.map((e) => {
    if (e.subMenu) {
      e.subMenu.forEach((sub) => {
        if (sub.activeNameList.indexOf($router.currentRoute.value.name) >= 0) {
          e.isShowSubMenu = true;
        }
      });
    }
    // else {
    e.isActive = e.activeNameList.indexOf($router.currentRoute.value.name) >= 0;
    // }
    return e;
  });
  console.log('layoutData.dataList', layoutData.dataList);
};

const getUserData = async () => {
  const accessToken = $functions.getLocalStorage(
    $constants.LOCAL_STORAGE.OAUTH_BACK_OFFICE_ACCESS_TOKEN
  );
  const data = $functions.decodeToken(accessToken);
  layoutData.userName = data.username;
  gUserAuthData.value = data;
  console.log('gUserAuthData', gUserAuthData.value);
};

setTimeout(() => {
  checkPath();
}, 1);
</script>

<style lang="scss">
.is-main-layout {
  display: flex;
}
</style>
